import Vue from 'vue'
import { makeCancellable, takeLatest } from 'vuex-cancellable-actions'

import { apiPost } from '../api'

export default { // log in, log out, refresh token
  namespaced: true,
  state: {
    token: localStorage.getItem('_token') || null,
    refreshToken: localStorage.getItem('_refreshToken') || null,
  },
  mutations: {
    updateTokens: (state, { token, refreshToken }) => {
      state.token = token
      state.refreshToken = refreshToken
      localStorage.setItem('_token', token)
      localStorage.setItem('_refreshToken', refreshToken)
    },
    logOut: (state) => {
      state.token = state.refreshToken = null
      localStorage.removeItem('_token')
      localStorage.removeItem('_refreshToken')
    },
  },
  actions: makeCancellable({
    register: (
      { commit, rootState, dispatch },
      { email, firstName, lastName, password, companyName }
    ) =>
      apiPost({
        rootState,
        dispatch,
        auth: false,
        retryAuth: false,
        url: '/api/company/register/',
        data: {
          email,
          firstName,
          lastName,
          password,
          companyName,
        },
      })
        .then(({ res, status }) => {
          // надо выбрать компанию (res.companies)
          // см. src/components/LoginModal.vue
          if (status === 300) { return res }
          commit('updateTokens', res)
          return res
        }),
    logIn: ({ commit, rootState, dispatch }, { email, password, companyCode = null }) =>
      apiPost({
        rootState,
        dispatch,
        auth: false,
        retryAuth: false,
        url: '/api/auth/login/',
        data: {
          email,
          password,
          ...(companyCode ? { companyCode } : {}),
        },
      })
        .then(({ res, status }) => {
          // надо выбрать компанию (res.companies)
          // см. src/components/LoginModal.vue
          if (status === 300) { return res }
          commit('updateTokens', res)
          return res
        }),
    bitrixLogIn: ({ commit, rootState, dispatch }, { domain, popup = true }) =>
      apiPost({
        rootState,
        dispatch,
        auth: false,
        retryAuth: false,
        url: '/api/auth/bitrix-login/',
        data: { domain, popup },
      })
        .then(({ res }) => {
          return res
        }),
    refresh: takeLatest(
      ({ state: { refreshToken }, commit, rootState, dispatch }) =>
        apiPost({
          rootState,
          dispatch,
          url: '/api/auth/refresh/',
          data: { refreshToken },
          auth: false,
          retryAuth: false,
        })
          .then(({ res }) => {
            commit('logOut')
            return Vue.nextTick(() => commit('updateTokens', res))
          })
          .catch(e => {
            dispatch('completeLogOut')
            throw e
          })
    ),
    completeLogOut: ({ commit }) => {
      // fixme добавить недостающие мутации или продумать централизованные
      //       сброс состояния к значениям по-умолчанию
      commit('logOut')
      commit('user/setCurrent', { user: null }, { root: true })
      commit('event/setList', { events: null }, { root: true })
      commit('integration/setMap', { integrations: null }, { root: true })
      commit('integration/setHealthChecks', { healthChecks: {} }, { root: true })
    },
  }),
}
